import {DeviceType} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {KeypadViewMobilePortrait, KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';
import {ScreenOrientedView} from '@gongxigames/framework/slot';

export class KeypadViewMobile extends ScreenOrientedView<any, any> {
    public static readonly NAME: symbol = Symbol('KeypadViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected readonly landscapeViewName: symbol = KeypadViewMobileLandscape.NAME;
    protected readonly portraitViewName: symbol = KeypadViewMobilePortrait.NAME;
}
